import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconClose: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.5887 2.25 2.25 6.5887 2.25 12C2.25 17.4111 6.5887 21.75 12 21.75C17.411 21.75 21.75 17.4111 21.75 12C21.75 6.5887 17.4111 2.25 12 2.25ZM16.8752 15.51L15.5102 16.8749L12 13.3648L8.49 16.8749L7.12493 15.51L10.6351 12L7.12493 8.48992L8.49 7.12514L12 10.635L15.5101 7.12514L16.8751 8.48992L13.365 12L16.8752 15.51Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconClose;
